import type { NewContainer } from '@sr/types';

export const templateRowsEqual = (left: NewContainer[], right: NewContainer[]) => {
  const normalize = (rows: NewContainer[]) =>
    rows.map((row) =>
      Object.fromEntries(
        Object.entries(row)
          .filter(([key, value]) => key !== 'id' && value !== '')
          .sort(([a], [b]) => a.localeCompare(b)),
      ),
    );

  return JSON.stringify(normalize(left)) === JSON.stringify(normalize(right));
};
export const applyTemplateRows = (rows: NewContainer[]) =>
  rows.map((row) => ({ ...row, id: crypto.randomUUID() }));
